const MONTH_INDEX: Record<string, number> = {
    jan: 0, january: 0,
    feb: 1, february: 1,
    mar: 2, march: 2,
    apr: 3, april: 3,
    may: 4,
    jun: 5, june: 5,
    jul: 6, july: 6,
    aug: 7, august: 7,
    sep: 8, sept: 8, september: 8,
    oct: 9, october: 9,
    nov: 10, november: 10,
    dec: 11, december: 11,
};

function isValidDate(value: unknown): value is Date {
    return value instanceof Date && !Number.isNaN(value.getTime());
}

function expandYear(year: string | number | undefined): number {
    const n = Number(year);
    if (!Number.isFinite(n)) return NaN;
    return n < 100 ? 2000 + n : n;
}

function localDate(year: number, monthIndex: number, day: number): Date | null {
    const date = new Date(year, monthIndex, day);
    if (
        date.getFullYear() === year
        && date.getMonth() === monthIndex
        && date.getDate() === day
    ) {
        return date;
    }
    return null;
}

export function parseQuoteDate(value: unknown, fallback: Date = new Date()): Date {
    if (isValidDate(value)) return new Date(value.getFullYear(), value.getMonth(), value.getDate());

    const fallbackDate = isValidDate(fallback) ? fallback : new Date();
    if (value === null || value === undefined || value === '') {
        return new Date(fallbackDate.getFullYear(), fallbackDate.getMonth(), fallbackDate.getDate());
    }

    const text = String(value).trim();
    if (!text) return new Date(fallbackDate.getFullYear(), fallbackDate.getMonth(), fallbackDate.getDate());

    const iso = text.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[T\s].*)?$/);
    if (iso) {
        const date = localDate(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
        if (date) return date;
    }

    const auNumeric = text.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{2,4})(?:\s.*)?$/);
    if (auNumeric) {
        const day = Number(auNumeric[1]);
        const monthIndex = Number(auNumeric[2]) - 1;
        const year = expandYear(auNumeric[3]);
        const date = localDate(year, monthIndex, day);
        if (date) return date;
    }

    const auText = text.match(/^(\d{1,2})(?:st|nd|rd|th)?\s+([a-z]+),?\s+(\d{2,4})$/i);
    if (auText) {
        const day = Number(auText[1]);
        const monthIndex = MONTH_INDEX[String(auText[2]).toLowerCase()];
        const year = expandYear(auText[3]);
        if (monthIndex !== undefined) {
            const date = localDate(year, monthIndex, day);
            if (date) return date;
        }
    }

    const parsed = new Date(text);
    if (isValidDate(parsed)) return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());

    return new Date(fallbackDate.getFullYear(), fallbackDate.getMonth(), fallbackDate.getDate());
}

export function formatQuoteDateCode(value: unknown, fallback: Date = new Date()): string {
    const date = parseQuoteDate(value, fallback);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${month}${year}`;
}
